'use client';
import { CopyrightText } from './CopyrightsText/CopyrightsText';
import { AppsLinks } from '@intigral/shared/components/AppsLinks';
import { SocialLinks } from '@intigral/shared/components/SocialLinks';
import { IFooterProps } from '../../interface/iFooter';
import styles from './copy.module.sass';
import cn from 'classnames';
import { Menu } from '@intigral/shared/components/Menu';

export const Footer = ({
    navLinks,
    appsLinks,
    socialMediaLinks,
    copyrightText,
    LinkComponent,
    noPaddingTop = false,
}: IFooterProps) => {
    return (
        <footer id={styles.footer} style={{ paddingTop: noPaddingTop ? '0' : 'auto' }}>
            <div className={cn(styles.container, 'container', 'full-width')} id="test">
                {/* Doubles as the mobile dropdown: MenuToggle flips body[data-nav] and CSS reveals
                    this. Header controls that belong here portal themselves in by this id —
                    see useMobileMenuPortal. Nothing relocates live DOM any more. */}
                <div className={styles.holder} id="ifshowmobilmenu">
                    <Menu className={styles.menu} navLinks={navLinks} LinkComponent={LinkComponent} />
                </div>
                <div>
                    {appsLinks ? <AppsLinks links={appsLinks} LinkComponent={LinkComponent} /> : ''}
                    {socialMediaLinks ? <SocialLinks links={socialMediaLinks} LinkComponent={LinkComponent} /> : ''}
                    <CopyrightText text={copyrightText} />
                </div>
            </div>
        </footer>
    );
};
